import React, { useState, useEffect, useContext, useRef } from 'react';
import Footer from '../components/footer';
import ComboboxAutocompleteAPI from '../components/combobox_autocomplete_api';
import { getEmployeesWithActiveContract } from "../services/api_calendar";
import { listOrganizationalUnits } from '../services/api_org_unit';
import { AuthContext } from '../contexts/auth';
import { EnvelopeIcon, BellIcon, TrashIcon } from '@heroicons/react/24/outline';
import { getCompanyAlerts, postAlertCompany, deleteAlertCompany, getCompanyAlertsReadbyList } from '../services/api_alerts';
import Swal from 'sweetalert2';
import Fetching from '../components/fetching';
import Toggle from '../components/toggle';
import Empty from '../components/empty';
import { Link } from 'wouter';
import Tooltip from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';
import PopoverComponentCustom from '../components/popover_component';
import moment from 'moment';


export default function BoardMessage() {
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedUnits, setSelectedUnits] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const { loading, token, profile } = useContext(AuthContext);
  const [fetching, setFetching] = useState(true)
  const [units, setUnits] = useState([]);
  const [dipendenti, setDipendenti] = useState([]);
  const [selectedCommunicationOption, setSelectedCommunicationOption] = useState({});
  const [alertsMessage, setAlertsMessage] = useState([]);
  const [notificationsMessage, setNotificationsMessage] = useState([]);
  const [selectedToggleOption, setSelectedToggleOption] = useState('Comunicazioni');
  const [currentPageAlerts, setCurrentPageAlerts] = useState(1);
  const [totalPagesAlerts, setTotalPagesAlerts] = useState(0);
  const [currentPageNotifications, setCurrentPageNotifications] = useState(1);
  const [totalPagesNotifications, setTotalPagesNotifications] = useState(0);
  const [titleError, setTitleError] = useState(null);
  const [messageError, setMessageError] = useState(null);
  const [recipientError, setRecipientError] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [filter, setFilter] = useState('active');
  const [searchQuery, setSearchQuery] = useState('');
  const titleRef = useRef(null);
  const messageRef = useRef(null);
  const recipientRef = useRef(null);
  const [page, setPage] = useState(1);
  const pageSize = 50; 
  const [readByData, setReadByData] = useState([]);
  const [readByVisible, setReadByVisible] = useState(false);
  const [selectedAlertId, setSelectedAlertId] = useState(null);
  const [loadingReadBy, setLoadingReadBy] = useState(false);
  const [errorLoadingReadby, setErrorLoadingReadby] = useState(false);
  const [currentPageReadby, setCurrentPageReadby] = useState(1);
  const [totalPagesReadby, setTotalPagesReadby] = useState(0);


  const isProfileComplete = profile.has_complete_profile;
  
  const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
  ))({
    '& .MuiTooltip-tooltip': {
      backgroundColor: '#a3a3a3',
      color: '#FFFFFF',
      fontSize: '0.8rem',
    },
  });

  useEffect(() => {
    const fetchUnits = async () => {
      setIsLoading(true);
      setIsError(false);

      try {
        const response = await listOrganizationalUnits(token, true, null, 'shifts');

        setUnits(response.data || [] );
      } catch (error) {
        console.error('Error fetching units:', error);
        {(error.response.status !== 402) &&
          setIsError(true);
          setIsLoading(false);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchUnits();
  }, [token]);

  useEffect(() => {
    const fetchAlertsData = async () => {
      setIsLoading(true);
      try {
        const alertsData = await getCompanyAlerts(token, currentPageAlerts, 10, 'comunication', 'alerts');
        setAlertsMessage(alertsData.results || []);
        setTotalPagesAlerts(Math.ceil(alertsData.count / 10));

        const notificationsData = await getCompanyAlerts(token, currentPageNotifications, 20, 'notification', 'alerts');
        setNotificationsMessage(notificationsData.results || []);
        setTotalPagesNotifications(Math.ceil(notificationsData.count / 20));        

        setIsError(false);
      } catch (error) {
        console.error('Error fetching alerts:', error);
        {(error.response.status !== 402) &&
          setIsError(true);
        }
      } finally {
        setIsLoading(false);
      }
    };
    if (token) {
      fetchAlertsData();
    }
  }, [token, currentPageAlerts, currentPageNotifications]);


  const handleNextPage = () => {
    if (selectedToggleOption === 'Comunicazioni') {
      if (currentPageAlerts < totalPagesAlerts) {
        setCurrentPageAlerts(prevPage => prevPage + 1);
      }
    } else if (selectedToggleOption === 'Notifiche') {
      if (currentPageNotifications < totalPagesNotifications) {
        setCurrentPageNotifications(prevPage => prevPage + 1);
      }
    }
  };

  const handlePreviousPage = () => {
    if (selectedToggleOption === 'Comunicazioni') {
      if (currentPageAlerts > 1) {
        setCurrentPageAlerts(prevPage => prevPage - 1);
      }
    } else if (selectedToggleOption === 'Notifiche') {
      if (currentPageNotifications > 1) {
        setCurrentPageNotifications(prevPage => prevPage - 1);
      }
    }
  };

  const handleNextPageReadby = () => {
    if (currentPageReadby < totalPagesReadby) {
      setCurrentPageReadby(prevPage => prevPage + 1);
    }
  };

  const handlePreviousPageReadby = () => {
    if (currentPageReadby > 1) {
      setCurrentPageReadby(prevPage => prevPage - 1);
    }
  };


  const handleOptionChange = (option) => {
    if (selectedOption === option) {
      setSelectedOption(null);
    } else {
      setSelectedOption(option);
      if (option !== 'employee') {
        setSelectedEmployees([]);
      }
      if (option !== 'unit') {
        setSelectedUnits([]);
        setSelectedCommunicationOption({});
      }
      if (option !== 'all') {
        
      }
      setRecipientError(null);
    }
  };

  const handleCheckboxChange = (event) => {
    setFilter(event.target.value);
  };

  const getFilterValue = () => {
    if (filter === 'active') return 'hr_active';
    if (filter === 'inactive') return 'contract_not_active';
    if (filter === 'all') return 'all';
    return null;
  };

  const handleEmployeeSelection = (employee) => {
    if (!employee) return;
  
    if (Array.isArray(selectedEmployees)) {
      if (selectedEmployees.some((e) => e.id === employee.id)) {
        setSelectedEmployees(selectedEmployees.filter((e) => e.id !== employee.id));
      } else {
        setSelectedEmployees([...selectedEmployees, employee]);
      }
    } else {
      setSelectedEmployees([employee]);
    }
    setSearchQuery(''); 
  };
  
  const handleUnitSelection = (unit) => {
    if (selectedUnits.some((selectedUnit) => selectedUnit.id === unit.id)) {
      setSelectedUnits(selectedUnits.filter((selectedUnit) => selectedUnit.id !== unit.id));
    } else {
      setSelectedUnits([...selectedUnits, unit]);
    }
  };

  const handleCreateAlert = async (event) => {
    event.preventDefault();

    const title = event.target.elements.title.value;
    const message = event.target.elements.comment.value;

    let isValid = true;

    if (titleError) {
      setTitleError(null);
    }
    if (messageError) {
      setMessageError(null);
    }
    if (recipientError) {
      setRecipientError(null);
    }

    if (!title) {
      setTitleError('Compila il campo');
      if (titleRef.current) {
        titleRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      isValid = false;
    }

    if (!message) {
      setMessageError('Compila il campo');
      if (isValid && messageRef.current) {
        messageRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      isValid = false;
    }

    if (!selectedOption) {
      setRecipientError('Seleziona almeno un destinatario');
      if (isValid && recipientRef.current) {
        recipientRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      isValid = false;
    } else if (selectedOption === 'unit' && (!selectedUnits || selectedUnits.length === 0)) {
      setRecipientError('Seleziona almeno un\'unità');
      if (isValid && recipientRef.current) {
        recipientRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      isValid = false;
    } else if (selectedOption === 'employee' && (!selectedEmployees || selectedEmployees.length === 0)) {
      setRecipientError('Seleziona almeno un dipendente');
      if (isValid && recipientRef.current) {
        recipientRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      isValid = false;
    }

    if (!isValid) {
      return;
    }


    const newAlertData = {
      title,
      message,
      send_to_all: selectedOption === 'all',
      category: 'comunication',
      organizational_units: selectedOption === 'unit' ? selectedUnits.map(unit => unit.id) : [],
      employees: selectedOption === 'employee' ? selectedEmployees.map(employee => employee.id) : []
    };
    
    try {
      const createdAlert = await postAlertCompany(token, newAlertData);

      setAlertsMessage(prevAlerts => [createdAlert, ...prevAlerts]);

      if (alertsMessage.length % 10 === 0) {
        setTotalPagesAlerts(prevTotal => prevTotal + 1);
      }

      Swal.fire({
        icon: 'success',
        title: 'Messaggio Inviato!',
        text: 'Il messaggio è stato inviato correttamente.',
        timer: 2500,
      });

      event.target.reset();
      setSelectedOption(null);
      setSelectedUnits([]);
      setSelectedEmployees([]);
      setSelectedCommunicationOption({});
    } catch (error) {
      console.error('Errore durante l\'invio del messaggio:', error);
      let errorMessage = 'Non è stato possibile inviare il messaggio. Per favore riprova.';
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        const errorMessages = [];
  
        Object.keys(errorData).forEach((key) => {
          const messageArray = errorData[key];
          if (Array.isArray(messageArray)) {
            errorMessages.push(...messageArray);
          } else if (typeof messageArray === 'string') {
            errorMessages.push(messageArray);
          }
        });
  
        if (errorMessages.length > 0) {
          errorMessage = errorMessages.join(' ');
        }
      }
  
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
    }
  };

  const handleShowDetails = (messageId) => {
    setShowDetails((prevDetailsVisibility) => ({
      ...prevDetailsVisibility,
      [messageId]: !prevDetailsVisibility[messageId]
    }));
  };

  const handleToggleChange = (selectedOption) => {
    setSelectedToggleOption(selectedOption);

    if (selectedOption === 'Comunicazioni') {
      setCurrentPageAlerts(1);
    } else {
      setCurrentPageNotifications(1);
    }
  };

  const handleDeleteAlert = async (id, title) => {
    Swal.fire({
      icon: "warning",
      title: 'Conferma eliminazione',
      text: `Stai eliminando l'avviso "${title}". Sei sicuro di voler procedere?`,
      showCancelButton: true,
      confirmButtonText: "Sì",
      cancelButtonText: "Annulla",
      cancelButtonColor: "#d1d5db",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await deleteAlertCompany(token, id);
          
          setAlertsMessage(prevAlerts => prevAlerts.filter(alert => alert.id !== id));

          setAlertsMessage(prevAlerts => prevAlerts.filter(alert => alert.id !== id));

          if (alertsMessage.length === 1 && currentPageAlerts > 1) {
            setCurrentPageAlerts(prevPage => prevPage - 1);
          }
          setTotalPagesAlerts(prevTotal => Math.ceil((prevTotal - 1) / 10));
  
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Avviso eliminato con successo!",
            showConfirmButton: false,
            timer: 1500
          });
        } catch (error) {
          console.error('Errore durante l\'eliminazione:', error);
          let errorMessage = 'Non è stato possibile eliminare l\'avviso. Per favore riprova.';
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            const errorMessages = [];
      
            Object.keys(errorData).forEach((key) => {
              const messageArray = errorData[key];
              if (Array.isArray(messageArray)) {
                errorMessages.push(...messageArray);
              } else if (typeof messageArray === 'string') {
                errorMessages.push(messageArray);
              }
            });
      
            if (errorMessages.length > 0) {
              errorMessage = errorMessages.join(' ');
            }
          }
      
          Swal.fire({
            icon: 'error',
            title: 'Errore',
            text: errorMessage,
            confirmButtonText: 'OK',
          });
        }
      };
    });
  };

  const handleToggleReadBy = (alertId) => {
    if (readByVisible && selectedAlertId === alertId) {
      setReadByVisible(false);
    } else {
      setSelectedAlertId(alertId);
      setCurrentPageReadby(1);
      setReadByVisible(true);
    }
  };

  useEffect(() => {
    const fetchReadByData = async () => {
      if (readByVisible && selectedAlertId) {
        try {
          setLoadingReadBy(true);
          setErrorLoadingReadby(false);
          const perPage = 20;
          const res = await getCompanyAlertsReadbyList(token, selectedAlertId, currentPageReadby, perPage, 'alerts');
          setReadByData(res.results || []);
          setTotalPagesReadby(Math.ceil(res.count / perPage));
        } catch (error) {
          console.error("Errore nel recupero dei dati:", error);
          setErrorLoadingReadby("Errore nel recupero dei dati.");
        } finally {
          setLoadingReadBy(false);
        }
      }
    };

    fetchReadByData();
  }, [currentPageReadby, readByVisible, selectedAlertId]);

  
  if(isLoading)
    return <Fetching />
  if (isError) return <div>Error loading data</div>;
 
  return (
    <div className="min-h-full">
      <PopoverComponentCustom title='Bacheca Avvisi' />
      {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4 mb-6">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti{' '}
              <Link
                to="/profilo/fatturazione"
                className="text-indigo-600 hover:text-indigo-800 underline"
              >
                cliccando qui
              </Link>
            </p>
          </div>
        </div>
      )}
      <main className="mt-10 px-8 pb-8">
        <form onSubmit={handleCreateAlert}>
          <div className='border border-gray-200 rounded-md shadow-sm p-5'>
            <div ref={titleRef}>
              <label htmlFor="title" className="block text-sm font-medium leading-6 text-gray-900">
                Titolo
              </label>
              <div className="mt-2">
                <input
                  type="text"
                  name="title"
                  id="title"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-300 sm:text-sm sm:leading-6"
                  placeholder="Titolo..."
                  onChange={() => setTitleError(null)}
                />
                {titleError && <p className="text-red-500 text-xs mt-1">{titleError}</p>}
              </div>
            </div>
            <div ref={messageRef} className="mt-4">
              <label htmlFor="comment" className="block text-sm font-medium leading-6 text-gray-900">
                Messaggio
              </label>
              <div className="mt-2">
                <textarea
                  rows={4}
                  name="comment"
                  id="comment"
                  className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-300 sm:text-sm sm:leading-6"
                  placeholder="Scrivi il tuo messaggio..."
                  defaultValue={''}
                  onChange={() => setMessageError(null)} 
                />
                {messageError && <p className="text-red-500 text-xs mt-1">{messageError}</p>}
              </div>
            </div>
            <div className="mt-4" ref={recipientRef}>
              <label className="block text-sm font-medium leading-6 text-gray-900">Invia a</label>
              <div className="mt-2 flex flex-col">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    checked={selectedOption === 'all'}
                    onChange={() => handleOptionChange('all')}
                    className="rounded text-indigo-600 focus:ring-indigo-600"
                  />
                  <label htmlFor="all" className="block text-sm font-medium ml-2 leading-6 text-gray-900">Tutti</label>
                </div>
                <div className="flex items-center mt-2">
                  <input
                    type="checkbox"
                    checked={selectedOption === 'unit'}
                    onChange={() => handleOptionChange('unit')}
                    className="rounded text-indigo-600 focus:ring-indigo-600"
                  />
                  <label htmlFor="unit" className="block text-sm font-medium ml-2 leading-6 text-gray-900">Seleziona Unità Organizzative</label>
                </div>
                <div className="flex items-center mt-2">
                  <input
                    type="checkbox"
                    checked={selectedOption === 'employee'}
                    onChange={() => handleOptionChange('employee')}
                    className="rounded text-indigo-600 focus:ring-indigo-600"
                  />
                  <label htmlFor="employee" className="block text-sm font-medium ml-2 leading-6 text-gray-900">Seleziona Dipendenti</label>
                </div>
                {recipientError && <p className="text-red-500 text-xs mt-1">{recipientError}</p>}
              </div>
            </div>

            {selectedOption === 'unit' && (
              <div className="mt-4 max-h-80 overflow-y-auto border">
                <h3 className='block sticky top-0 text-sm font-bold leading-6 text-indigo-800 uppercase bg-indigo-200 p-3'>
                  Seleziona Unità Organizzative
                </h3>
                <div className='bg-white divide-y divide-gray-200'>
                  {units
                    .slice()
                    .filter((unit) => !selectedUnits.some((selectedUnit) => selectedUnit.id === unit.id))
                    .map((unit) => (
                      <div key={unit.id} className="col-span-3 block text-sm font-medium leading-6 text-gray-600 cursor-pointer border-t">
                        <div
                          className="text-sm font-medium leading-6 text-gray-600 cursor-pointer hover:bg-indigo-50 p-2 px-4 justify-between items-center grid grid-cols-5"
                          onClick={() => handleUnitSelection(unit)}
                        >
                          <div className='col-span-3'>{unit.name}</div>
                          <div className='col-span-1 text-xs'>GESTORI: {unit.managers}</div>
                          <div className='col-span-1 text-xs'>DIPENDENTI: {unit.resources}</div>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            )}

            {selectedUnits.length > 0 && selectedOption === 'unit' && (
              <div className="border mt-6">
                <h3 className='block text-sm font-bold leading-6 text-indigo-800 uppercase bg-indigo-200 p-3'>
                  Destinatari: {selectedUnits.length} unità
                </h3>
                <div className='block text-xs font-medium ml-2 leading-6 text-gray-700 mb-2'>
                  Puoi rimuovere le Unità dalla lista dei destinatari cliccando sul nome
                </div>
                <div className='max-h-80 overflow-y-auto'>
                  {selectedUnits.map((unit) => (
                    <button
                      key={unit.id}
                      className="block w-full text-left grid grid-cols-5 hover:bg-indigo-50"
                      onClick={() => handleUnitSelection(unit)}
                    >
                      <div className='col-span-3 block text-sm font-medium leading-6 text-gray-600 cursor-pointer p-2 px-4 border-t'>
                        {unit.name}
                      </div>
                      <div className='col-span-1 block text-xs font-medium leading-6 text-gray-600 cursor-pointer p-2 border-t'>
                        GESTORI: {unit.managers}
                      </div>
                      <div className='col-span-1 block text-xs font-medium leading-6 text-gray-600 cursor-pointer p-2 border-t'>
                        DIPENDENTI: {unit.resources}
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {selectedOption === 'employee' && (
              <div className="mt-4 max-h-80 overflow-y-auto border">
                <h3 className='block sticky top-0 text-sm z-10 font-bold leading-6 bg-indigo-200 text-indigo-800 uppercase p-3'>
                  Seleziona Dipendenti
                </h3>
                <div className='border border-b p-2 sticky top-12 bg-white z-10'>
                  <p className='block text-xs font-medium ml-2 leading-6 text-gray-900 uppercase tracking-wider'>
                    Visualizza:
                  </p>
                  <div className="flex items-center space-x-4 mt-2">
                    <label className="flex items-center space-x-2 text-sm font-medium text-gray-900">
                      <input
                        type="checkbox"
                        value="active"
                        checked={filter === 'active'}
                        onChange={handleCheckboxChange}
                        className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                      />
                      <span>Contratti Attivi</span>
                    </label>
                    <label className="flex items-center space-x-2 text-sm font-medium text-gray-900">
                      <input
                        type="checkbox"
                        value="inactive"
                        checked={filter === 'inactive'}
                        onChange={handleCheckboxChange}
                        className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                      />
                      <span>Contratti Non Attivi</span>
                    </label>
                    <label className="flex items-center space-x-2 text-sm font-medium text-gray-900">
                      <input
                        type="checkbox"
                        value="all"
                        checked={filter === 'all'}
                        onChange={handleCheckboxChange}
                        className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                      />
                      <span>Tutti</span>
                    </label>
                  </div>
                  <div className='col-span-1 pt-4 pb-2 h-60'>
                    <ComboboxAutocompleteAPI
                      getData={async (query) => {
                        if (query.trim() === '') {
                          return Promise.resolve([]);
                        }

                        const page = 1;
                        const pageSize = 5;

                        try {
                          const filterValue = getFilterValue();
                          const res = await getEmployeesWithActiveContract(token, query, filterValue, null, page, pageSize);
                          const employeesArray = Array.isArray(res.results) ? res.results : [];
                          
                          // Filtra i dipendenti già selezionati
                          const filteredEmployees = employeesArray.filter(
                            (employee) => !selectedEmployees.some((selected) => selected.id === employee.id)
                          );

                          return filteredEmployees;
                        } catch (error) {
                          console.error("Errore durante il recupero dei dati:", error);
                          return [];
                        }
                      }}
                      getDisplay={(employee) => 
                        employee.last_name && employee.first_name 
                          ? `${employee.last_name} ${employee.first_name}` 
                          : employee.name || employee.cf || ''
                      }
                      getId={(employee) => employee.id}
                      onChange={handleEmployeeSelection}
                      currentValue={searchQuery}
                      placeholder="Digita per cercare il dipendente"
                      positionClass="relative"
                    />
                  </div>
                </div>
              </div>
            )}

            {selectedEmployees?.length > 0 && selectedOption === 'employee' && (
              <div className="border mt-6">
                <h3 className='block text-sm font-bold leading-6 text-indigo-800 uppercase bg-indigo-200 p-3'>
                  Destinatari: {selectedEmployees?.length} dipendenti
                </h3>
                <div className='block text-xs font-medium ml-2 leading-6 text-gray-700 mb-2'>
                  Puoi rimuovere i dipendenti dalla lista dei destinatari cliccando sul nome
                </div>
                <div className='max-h-80 overflow-y-auto'>
                  {selectedEmployees?.map((employee) => (
                    <button
                      key={employee.id}
                      className="block w-full text-left"
                      onClick={() => handleEmployeeSelection(employee)}
                    >
                      <div className='block text-sm font-medium leading-6 text-gray-600 cursor-pointer hover:bg-indigo-50 p-2 px-4 border-t'>
                        {employee.last_name && employee.first_name
                          ? `${employee.last_name} ${employee.first_name}`
                          : employee.cf}
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {selectedOption === 'all' ? (
              <div className="p-2 mt-2 font-semibold text-center text-sm text-gray-700">
                Il messaggio verrà inviato a tutti i dipendenti con contratto attivo
              </div>
            ) : selectedOption === 'unit'  && selectedUnits.length ? (
              <div className="p-2 mt-2 font-semibold text-center text-sm text-gray-700">
                Il messaggio verrà inviato ai dipendenti con contratto attivo che fanno parte dell'unità selezionata
              </div>
            ) : null}

            <div className="justify-center flex mt-3">
              <button
                type="submit"
                className="border block rounded-md px-3 py-2 mr-2 text-center text-sm font-semibold text-white bg-indigo-600 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-200"
              >
                Invia Messaggio
              </button>
            </div>
          </div>
        </form>

        <div className='border border-gray-200 rounded-md shadow-sm p-5 mt-4'>
          <div className='justify-center flex w-full'>
            <Toggle
                color="indigo"
                gradeBgColor="600"
                optionLeft='Comunicazioni'
                optionRight='Notifiche'
                selectedOption={selectedToggleOption}
                onChange={handleToggleChange}
            />
          </div>
          {selectedToggleOption === 'Comunicazioni' && alertsMessage.length > 0 &&  
            <div className="mt-4">
              <ul role="list">
                {alertsMessage.map((message) => (
                  <li key={message.id}>
                    <div className="relative pb-4">
                      <div className="relative flex space-x-3 cursor-pointer hover:bg-indigo-50" onClick={() => handleShowDetails(message.id)}>
                        <div>
                          <span className="h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white bg-indigo-600">
                            <EnvelopeIcon className='h-5 w-5 text-white' />
                          </span>
                        </div>
                        <div className="flex flex-col sm:flex-row min-w-0 w-full flex-1 justify-between space-y-2 sm:space-y-0 sm:space-x-4 pt-1.5">
                          <p className="text-sm text-gray-700 uppercase">
                              {message.title}{' '}
                          </p>
                          <div className="whitespace-normal text-right justify-end text-sm text-gray-500">
                              <time dateTime={message.created_at}>{new Date(message.created_at).toLocaleString()}</time>
                          </div>
                        </div>
                        <CustomTooltip title="Elimina avviso" placement="top-start">
                          <div 
                            className='items-center flex hover:text-indigo-800 cursor-pointer' 
                            onClick={(e) => { 
                              e.stopPropagation();
                              handleDeleteAlert(message.id, message.title);
                            }}
                          >
                            <TrashIcon className='w-5 h-5 hover:text-red-500' />
                          </div>
                        </CustomTooltip>
                      </div>
                      {showDetails[message.id] && (
                        <div className='container p-4 ml-8'>
                          <div className='pr-4'>
                            <span className="tracking-wider text-xs uppercase text-gray-600">Messaggio: </span>
                            <div className="text-sm text-gray-800 max-h-32 overflow-y-auto">
                              <span className="block">
                                {message.message.split('\n').map((line, index) => (
                                  <p key={index} className="break-words">
                                    {line}
                                  </p>
                                ))}
                              </span>
                            </div>
                            <hr className="bg-indigo-600 mt-2 pr-2 pr-4" style={{ height: '2px' }} />
                            <div className="text-sm text-gray-800 pr-2 py-2">
                              <span className="tracking-wider text-xs uppercase text-gray-600">Inviato a: </span>
                              
                              {message.organizational_units && Array.isArray(message.organizational_units) && message.organizational_units.length > 0 ? (
                                <ul className="grid grid-cols-2 list-disc ml-6">
                                  {message.organizational_units_details && Array.isArray(message.organizational_units_details) ? (
                                    message.organizational_units_details.map((organitazionalUnit) => (
                                      <li key={organitazionalUnit.id} className="flex items-center text-sm text-gray-800">
                                        <span className="block w-1.5 h-1.5 mr-2 bg-indigo-600 rounded-full"></span>
                                          Unità organizzativa: {organitazionalUnit.name}
                                      </li>
                                    ))
                                  ) : (
                                    <li key="no-employees" className="flex items-center text-sm text-gray-800">
                                      Nessuna unità organizzativa trovata
                                    </li>
                                  )}
                                </ul>
                              ) : message.send_to_all ? (
                                'Tutti'
                              ) : message.employees && Array.isArray(message.employees) && message.employees.length > 0 ? (
                                <div className="max-h-32 overflow-y-auto">
                                  <ul className="grid grid-cols-2 list-disc ml-6">
                                    {message.employees_details && Array.isArray(message.employees_details) ? (
                                      message.employees_details
                                        .sort((a, b) => {
                                          return a.cf.localeCompare(b.cf);
                                        })
                                        .map((employee) => (
                                          <li key={employee.id} className="flex items-center text-xs text-gray-800">
                                            <span className="block w-1.5 h-1.5 mr-2 bg-indigo-600 rounded-full"></span>
                                            {employee.last_name && employee.first_name ? (
                                              <>{employee.last_name} {employee.first_name}</>
                                            ) : (
                                              <>{employee.cf}</>
                                            )}
                                          </li>
                                        ))
                                    ) : (
                                      <li key="no-employees" className="flex items-center text-xs text-gray-800">
                                        Nessun dipendente trovato
                                      </li>
                                    )}
                                  </ul>
                                </div>
                              ) : (
                                'Nessuno'
                              )}
                            </div>
                            <hr className="bg-indigo-500 mt-2 pr-2" style={{ height: '2px' }} />
                          </div>
                          <div className="text-sm text-gray-800 pt-2">
                            <div className="flex items-center space-x-2">
                              <span className="tracking-wider text-xs uppercase text-gray-600 me-3">
                                Letto da: {message?.read_by}
                              </span>

                              {Number(message?.read_by) > 0 && (
                                <button
                                  className="border rounded-md px-2 py-1 text-center text-xs font-semibold text-white bg-indigo-600 shadow-sm hover:bg-indigo-500"
                                  onClick={() => handleToggleReadBy(message.id)}
                                >
                                  {readByVisible && selectedAlertId == message.id ? 'Nascondi' : 'Visualizza'}
                                </button>
                              )}
                            </div>

                            {loadingReadBy &&  <p className='text-sm text-gray-500'>Caricamento...</p>}
                            {errorLoadingReadby && <p className="text-sm text-gray-600">⚠️ Errore nel recupero dei dati.</p>}
                            {!loadingReadBy && !errorLoadingReadby && readByVisible && selectedAlertId == message.id && (
                              <div className="mt-4 border p-4 rounded-md shadow bg-white">
                                <div className="flex justify-between items-center mb-2">
                                  <h3 className="text-sm font-semibold text-gray-800">Dipendenti</h3>
                                </div>
                                <ul className="text-sm text-gray-700 space-y-1 max-h-60 overflow-y-auto">
                                  {readByData.map(({ employee, read_at }, index) => (
                                    <li key={index} className="border-b pb-1">
                                      {employee.last_name} {employee.first_name} – <span className="text-gray-500 text-xs">{moment(read_at).format('DD/MM/YYYY')} - {moment(read_at).format('HH:mm:ss')}</span>
                                    </li>
                                  ))}
                                </ul>

                                {readByData.length > 0 && totalPagesReadby > 1 && (
                                  <div className="flex items-center justify-between mt-3">
                                    <button
                                      onClick={handlePreviousPageReadby}
                                      disabled={currentPageReadby === 1}
                                      className={`border rounded-md shadow-sm text-sm font-semibold text-center px-2 py-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                                        currentPageReadby === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                                      }`}
                                    >
                                      Pagina precedente
                                    </button>

                                    <div className="text-sm font-semibold text-gray-800">
                                      Pagina {currentPageReadby} di {totalPagesReadby}
                                    </div>

                                    <button
                                      onClick={handleNextPageReadby}
                                      disabled={currentPageReadby === totalPagesReadby}
                                      className={`border rounded-md shadow-sm text-sm font-semibold text-center px-2 py-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                                        currentPageReadby === totalPagesReadby ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                                      }`}
                                    >
                                      Pagina successiva
                                    </button>
                                  </div>
                                )}

                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </li>
                ))}
              </ul>

              {/* Paginazione */}
              {selectedToggleOption === 'Comunicazioni' && alertsMessage.length > 0 && totalPagesAlerts > 1 && (
                <div className="flex items-center justify-between mt-4">
                  <button
                    onClick={handlePreviousPage}
                    disabled={currentPageAlerts === 1}
                    className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                      currentPageAlerts === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                    }`}
                  >
                    Pagina precedente
                  </button>

                  <div className="text-sm font-semibold text-gray-800">
                    Pagina {currentPageAlerts} di {totalPagesAlerts}
                  </div>

                  <button
                    onClick={handleNextPage}
                    disabled={currentPageAlerts === totalPagesAlerts}
                    className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                      currentPageAlerts === totalPagesAlerts ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                    }`}
                  >
                    Pagina successiva
                  </button>
                </div>
              )}
            </div>
          }

          {selectedToggleOption === 'Comunicazioni' && alertsMessage.length === 0 &&  (<Empty />)}

          {selectedToggleOption === 'Notifiche' && notificationsMessage.length > 0 && 
            <div className="mt-4">
              <ul role="list">
                {notificationsMessage.map((message) => (
                  <li key={message.id}>
                    <div className="relative pb-4">
                      <div className="relative flex flex-col md:flex-row space-x-3 hover:bg-indigo-50 p-3 border-b border-gray-200">
                        <div className="flex items-top space-x-2 md:w-1/3">
                          <span className="h-8 w-8 flex-shrink-0 rounded-full flex items-center justify-center ring-8 ring-white bg-indigo-600">
                            <BellIcon className="h-5 w-5 text-white" />
                          </span>
                          <p className="text-sm text-gray-700 uppercase flex-1">
                            {message.title}
                          </p>
                        </div>

                        <div className="flex-1 md:w-1/3 text-left">
                          <p className="text-sm text-gray-700">{message.message}</p>
                        </div>

                        <div className="flex-1 md:w-1/3 text-left md:text-right mt-2 md:mt-0">
                          <p className="text-xs text-gray-800 font-semibold text-left">Inviata a:</p>
                          {message.employees_details && Array.isArray(message.employees_details) && message.employees_details.length > 0 ? (
                            <ul className="text-xs text-gray-800">
                              {message.employees_details
                                .sort((a, b) => a.cf.localeCompare(b.cf))
                                .map((employee) => (
                                  <li key={employee.id} className="flex items-center">
                                    <span className="block w-1.5 h-1.5 mr-2 bg-indigo-600 rounded-full"></span>
                                    {employee.last_name && employee.first_name ? (
                                      <>{employee.last_name} {employee.first_name}</>
                                    ) : (
                                      <>{employee.cf}</>
                                    )}
                                  </li>
                                ))}
                            </ul>
                          ) : (
                            <p className="text-xs text-gray-800 text-left">Azienda</p>
                          )}
                          <p className="text-xs text-gray-800 font-semibold mt-1 text-left">
                            Letta da: {message.read_by}
                          </p>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>

              {/* Paginazione */}
              {selectedToggleOption === 'Notifiche' && notificationsMessage.length > 0 && totalPagesNotifications > 1 && (
                <div className="flex items-center justify-between mt-4">
                  <button
                    onClick={handlePreviousPage}
                    disabled={currentPageNotifications === 1}
                    className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                      currentPageNotifications === 1 ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                    }`}
                  >
                    Pagina precedente
                  </button>

                  <div className="text-sm font-semibold text-gray-800">
                    Pagina {currentPageNotifications} di {totalPagesNotifications}
                  </div>

                  <button
                    onClick={handleNextPage}
                    disabled={currentPageNotifications === totalPagesNotifications}
                    className={`border rounded-md shadow-sm text-sm font-semibold text-center px-3 py-2 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${
                      currentPageNotifications === totalPagesNotifications ? 'text-gray-800 cursor-not-allowed hover:bg-gray-200' : 'hover:bg-gray-200'
                    }`}
                  >
                    Pagina successiva
                  </button>
                </div>
              )}
            </div>
          }

          {selectedToggleOption === 'Notifiche' && notificationsMessage.length === 0 && (<Empty />)} 

        </div>
        
      </main>
      <Footer />
    </div>
  );
}
